import { useState, useEffect } from "react";
import styles from "./TurnType.module.css";
import { setAfternoonType } from "../../services/newdaily";

const OPTIONS = [
  { id: 2, label: "Completa" },
  { id: 1, label: "Partida" },
];

const TurnType = ({ fecha, empleadoId, value, onChange }) => {
  const [selected, setSelected] = useState(
    value != null ? Number(value) : 2
  );
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setSelected(value != null ? Number(value) : 2);
  }, [value]);

  const select = async (val) => {
    if (saving) return;

    setSelected(val);
    onChange?.(val);

    try {
      setSaving(true);
      await setAfternoonType({
        empleado: empleadoId,
        fecha,
        tipoTarde: val,
      });
    } catch (e) {
      console.error("Error guardando Tipo_Tarde:", e);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className={styles.group} role="radiogroup" aria-label="Tipo de tarde">
      {OPTIONS.map((opt) => {
        const active = selected === opt.id;
        return (
          <div
            key={opt.id}
            className={`${styles.item} ${active ? styles.active : ""} ${saving ? styles.disabled : ""}`}
            role="radio"
            aria-checked={active}
            tabIndex={0}
            onClick={() => select(opt.id)}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") select(opt.id);
            }}
          >
            <span className={styles.radio}>
              <span className={styles.radioInner} />
            </span>
            <span className={styles.label}>{opt.label}</span>
          </div>
        );
      })}
    </div>
  );
};

export default TurnType;
